import { render, staticRenderFns } from "./DataField.vue?vue&type=template&id=12374f8d&scoped=true&"
import script from "./DataField.vue?vue&type=script&lang=js&"
export * from "./DataField.vue?vue&type=script&lang=js&"
import style0 from "./DataField.vue?vue&type=style&index=0&id=12374f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12374f8d",
  null
  
)

export default component.exports